/*
  clikt. — "Ask Clikt" in the side rail.

  The assistant ships its own launcher: a waving-hand bubble plus a "Clikt
  assistant online" banner, floating over the bottom right of every page.
  Dale wants the way in to be part of the site furniture instead — the glowing
  mark at the foot of the right-hand rail.

  So this does two things:

    1. Hides the assistant's own launcher.
    2. Points the rail's Ask Clikt at the assistant's open button.

  The widget renders inside a shadow root with `all: initial`, which is a
  sealed box as far as the theme's stylesheets are concerned — nothing in
  clikt.css can reach it. The only way in is to find the host element and put
  a style tag inside its shadow root, which is what this does.

  The rail link is real markup pointing at the contact page, and is only
  upgraded once the assistant is actually on the page. If the script is slow,
  blocked, or the service is down, the link still goes somewhere useful. A
  launcher that silently does nothing is worse than no launcher.
*/
(function () {
  'use strict';

  /* ✓ Dale 27 Sep 2026: only where the rail (and its Ask Clikt) is on screen — the rail's own breakpoint. Below it
     (phones, tablets) the rail is hidden, so the assistant's own bubble stays, as it did on Squarespace. */
  var HIDE_LAUNCHER = '@media screen and (min-width: 1200px) and (min-height: 620px) { .launch { display: none !important; } }';
  var MARK = 'data-clikt-rail-controlled';

  /*
    The widget is one of a handful of shadow hosts on the page (Shopify adds
    its own). It is identified by what is inside it, not by a class name we
    do not control.
  */
  function findWidget() {
    var nodes = document.body ? document.body.children : [];
    for (var i = 0; i < nodes.length; i++) {
      var root = nodes[i].shadowRoot;
      if (root && root.querySelector('.launch .btn')) return root;
    }
    return null;
  }

  function hideOwnLauncher(root) {
    if (root.querySelector('[' + MARK + ']')) return;
    var style = document.createElement('style');
    style.setAttribute(MARK, '');
    style.textContent = HIDE_LAUNCHER;
    root.appendChild(style);
  }

  /* The 3D builder fills the screen: the assistant stays out of its way (the bubble sat over Place order). */
  function followBuilder(root) {
    var host = root.host;
    if (!host || host.getAttribute(MARK) !== null) return;
    host.setAttribute(MARK, '');
    var sync = function () {
      host.style.display = document.documentElement.classList.contains('clikt-cfg-open') ? 'none' : '';
    };
    new MutationObserver(sync).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    sync();
  }

  function wire(root) {
    hideOwnLauncher(root);
    followBuilder(root);

    var links = document.querySelectorAll('[data-clikt-ask]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].getAttribute(MARK) !== null) continue;
      links[i].setAttribute(MARK, '');
      links[i].setAttribute('role', 'button');
      links[i].addEventListener('click', function (e) {
        var open = root.querySelector('.launch .btn');
        /* No button means the widget changed shape — let the link do its job. */
        if (!open) return;
        e.preventDefault();
        open.click();
      });
    }
  }

  /*
    The widget script is deferred and mounts whenever it mounts, so poll
    briefly rather than assuming it is there. Ten seconds is long enough for
    a slow connection and short enough that a blocked script does not leave
    an interval running for the life of the page.
  */
  var waited = 0;
  var timer = window.setInterval(function () {
    var root = findWidget();
    if (root) {
      window.clearInterval(timer);
      wire(root);
      return;
    }
    waited += 300;
    if (waited >= 10000) window.clearInterval(timer);
  }, 300);
})();
